import { useState, useRef } from 'react';
import ChatbotFloatingButton from 'components/Chatbot/ChatbotFloatingButton';
import ChatbotLogic from 'components/Chatbot/ChatbotLogic';
import { IChatMessage } from 'interfaces/components/chatbot/chatbot';
import { ChatbotData } from 'utils/helpers/chatbotHelpers';

const Chatbot = () => {
  const [isPopupOpen, setIsPopupOpen] = useState(false);
  const [messages, setMessages] = useState<IChatMessage[]>([]);
  const [messageSources, setMessageSources] = useState<Record<string, any[]>>(
    {}
  );
  const [chatbotData, setChatbotData] = useState<ChatbotData | null>(null);

  const buttonRef = useRef<HTMLButtonElement>(null);

  const handleTogglePopup = () => {
    setIsPopupOpen(!isPopupOpen);
  };

  const handleClosePopup = () => {
    setIsPopupOpen(false);
  };

  return (
    <>
      <ChatbotFloatingButton
        ref={buttonRef}
        onClick={handleTogglePopup}
        isOpen={isPopupOpen}
      />
      <ChatbotLogic
        isOpen={isPopupOpen}
        onClose={handleClosePopup}
        messages={messages}
        setMessages={setMessages}
        messageSources={messageSources}
        setMessageSources={setMessageSources}
        chatbotData={chatbotData}
        setChatbotData={setChatbotData}
      />
    </>
  );
};

export default Chatbot;
